import type { ReactNode } from "react";
import { count } from "@/lib/plural";
import { FINDINGS, NOT_MEASURED, fmtAvg, type FeedbackRow } from "./model";

export function Card({ eyebrow, tone, children, testId }: { eyebrow: string; tone?: "warn" | "acc"; children: ReactNode; testId: string }) {
  const fg = tone === "warn" ? "var(--warn)" : tone === "acc" ? "var(--accdim)" : "var(--bd)";
  return (
    <section className="rounded-md bg-card" style={{ border: `1px solid ${fg}` }} data-testid={testId}>
      <div className={`border-b border-bd px-3.5 py-[9px] font-mono text-[10.5px] uppercase tracking-[.06em] ${tone === "warn" ? "text-warn" : tone === "acc" ? "text-accdim" : "text-mut"}`}>{eyebrow}</div>
      <div className="flex flex-col gap-3 px-3.5 py-3">{children}</div>
    </section>
  );
}

/** Отзывы на шагах: средняя оценка и число — по шагам маршрута, где отзывы есть. */
export function Feedback({ rows }: { rows: FeedbackRow[] }) {
  return (
    <Card eyebrow="отзывы на шагах" testId="feedback">
      {rows.length === 0 ? (
        <div className="flex flex-col gap-1" data-testid="feedback-empty">
          <span className="text-[13px] text-ink">отзывов пока нет</span>
          <span className="text-[12px] leading-[1.45] text-ink2">Студенты оставляют оценку и текст на экране шага — здесь появятся средняя и число отзывов.</span>
        </div>
      ) : (
        <ul className="m-0 flex flex-col gap-2 p-0">
          {rows.map((r) => (
            <li key={r.step.id} className="grid grid-cols-[minmax(0,1fr)_auto_auto] items-baseline gap-x-3" data-testid="feedback-row">
              <span className="min-w-0">
                <span className="block truncate text-[13px] text-ink">{r.step.title}</span>
                <span className="font-mono text-[10.5px] text-mut">{r.step.track}</span>
              </span>
              <span className="font-mono text-[13px] font-semibold text-acc" data-testid="feedback-avg">
                ★ {fmtAvg(r.avg)}
              </span>
              <span className="font-mono text-[11px] text-ink2" data-testid="feedback-n">
                {count(r.n, "отзыв", "отзыва", "отзывов")}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}

/** Дословный блок правила 1 CLAUDE.md. */
export function NotMeasured({ text }: { text: string }) {
  return (
    <Card eyebrow="чего мы не меряем" tone="acc" testId="not-measured">
      <p className="m-0 text-[13px] leading-[1.5] text-ink">{text || NOT_MEASURED}</p>
    </Card>
  );
}

/** Выводы по курсу — три пункта макета дословно. Это ревью курса, не расчёт из данных. */
export function Findings() {
  return (
    <Card eyebrow="что чинить в курсе" tone="warn" testId="findings">
      <ul className="m-0 flex flex-col gap-3.5 p-0">
        {FINDINGS.map((f) => (
          <li key={f.title} className="flex flex-col gap-1">
            <span className="text-[13px] font-medium leading-[1.35] text-ink">{f.title}</span>
            <span className="text-[12px] leading-[1.45] text-ink2">{f.body}</span>
            <span className="font-mono text-[10.5px] text-mut">{f.where}</span>
          </li>
        ))}
      </ul>
      <span className="text-[11px] text-mut">выводы ревью курса по ML-осень-2026 — обновляются вручную</span>
    </Card>
  );
}
